export const MORE_INFO_TEXTS = {
  LABEL: 'Подробнее',
};
